import { render, staticRenderFns } from "./CustomTab.vue?vue&type=template&id=d64d057e&scoped=true"
import script from "./CustomTab.vue?vue&type=script&lang=js"
export * from "./CustomTab.vue?vue&type=script&lang=js"
import style0 from "./CustomTab.vue?vue&type=style&index=0&id=d64d057e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64d057e",
  null
  
)

export default component.exports